<template>
  <div v-if="data">
    <Topbar />
    <section class="member-profile p-0">
      <div class="p-0">
        <div class="row mx-lg-4 mx-1 border-bottom-1">
          <div class="company-logo w-lg-50 w-md-50 w-25">
            <img v-if="data.logo" :src="data.logo" alt="" />
            <img v-else :src="$root.noimage" alt="" />
          </div>
          <div class="company-name w-lg-50 w-md-50 m-0 w-75">
            <h1>{{ data.company_name }}</h1>
            <strong
              >{{ __("Established Year") }} - {{ data.established_year }} |
              {{ __("Total Employee") }}: {{ data.total_employee }}</strong
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 m-0">
            <div class="about-body">
              <h2 class="wow fadeInLeft" data-wow-delay="0.2s">
                {{ __("About Us") }}
              </h2>
              <div
                v-if="data.about_us && $root.lang == 'en'"
                v-html="data.about_us"
                class="wow fadeInLeft company-about-us"
                data-wow-delay="0.7s"
              ></div>
              <div
                v-if="data.about_us_japan && $root.lang == 'jp'"
                v-html="data.about_us_japan"
                class="wow fadeInLeft company-about-us"
                data-wow-delay="0.7s"
              ></div>
            </div>
          </div>
          <div class="col-md-6 m-0">
            <div class="representative wow fadeInRight" data-wow-delay="0.2s">
              <h2 class="wow fadeInRight" data-wow-delay="0.2s">
                {{ __("Representative Info") }}
              </h2>
              <ul class="representative-details">
                <li class="wow fadeInRight" data-wow-delay="0.4s">
                  <i class="fa fa-user-o"></i> <b>{{ __("Name") }}:</b>
                  <span v-if="$root.lang == 'en'">
                    {{ data.rep_name }}
                  </span>
                  <span v-if="$root.lang == 'jp'">
                    {{ data.rep_name_japan }}
                  </span>
                </li>
                <li class="wow fadeInRight" data-wow-delay="0.6s">
                  <i class="fa fa-envelope"></i>
                  <b>{{ __("Email") }}:</b>{{ data.rep_email }}
                </li>
                <li class="wow fadeInRight" data-wow-delay="0.8s">
                  <i class="fa fa-cubes"></i> <b>{{ __("Designation") }}:</b>
                  <span v-if="$root.lang == 'en'">
                    {{ data.rep_designation }}
                  </span>
                  <span v-if="$root.lang == 'jp'">
                    {{ data.rep_designation_japan }}
                  </span>
                </li>
                <li class="wow fadeInRight" data-wow-delay="0.9s">
                  <i class="fa fa-phone"></i> <b>{{ __("Phone") }}:</b>
                  {{ data.rep_phone }}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row m-3">
          <div class="col-md-4 my-lg-3 my-4">
            <div class="bulate-point">
              <h5><i class="fa fa-sitemap"></i>{{ __("Services") }}</h5>
            </div>
            <div class="card card-body" v-if="Object(data.service).length > 0">
              <ul class="service">
                <li v-for="(service, index) in data.service" :key="index">
                  <i class="fa fa-angle-double-right"></i>
                  <span v-if="$root.lang == 'en'">
                    {{ service.name }}
                  </span>
                  <span v-if="$root.lang == 'jp'">
                    {{ service.name_japan }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-md-4 my-lg-3 my-4">
            <div
              class="bulate-point-middle"
              v-if="Object(data.service).length > 0"
            >
              <h5><span class="fa fa-globe"></span> {{ __("Technology") }}</h5>
            </div>
            <div
              class="card card-body"
              style="margin: 0 auto; background: #20c997; color: white"
            >
              <ul class="service">
                <li v-for="(technology, index) in data.technology" :key="index">
                  <i class="fa fa-angle-double-right"></i>
                  <span v-if="$root.lang == 'en'">
                    {{ technology.name }}
                  </span>
                  <span v-if="$root.lang == 'jp'">
                    {{ technology.name_japan }}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div class="col-md-4 my-lg-3 my-4">
            <div class="bulate-point">
              <h5><i class="fa fa-window-restore"></i> {{ __("Products") }}</h5>
            </div>
            <div class="card card-body" v-if="Object(data.product).length > 0">
              <ul class="service">
                <li v-for="(product, index) in data.product" :key="index">
                  <i class="fa fa-angle-double-right"></i>
                  <span v-if="$root.lang == 'en'">
                    {{ product.name }}
                  </span>
                  <span v-if="$root.lang == 'jp'">
                    {{ product.name_japan }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="client p-0">
      <div class="row m-3">
        <div
          class="col-md-6 my-lg-3 my-4"
          v-if="(data.client && data.client[0].logo) || data.client[0].link"
        >
          <div class="client-box">
            <h4><i class="fa fa-users"></i>{{ __("Clients") }}</h4>
            <div class="card card-body" v-if="Object(data.client).length > 0">
              <div class="scroll-height">
                <div class="row m-0 p-0">
                  <div
                    class="col-md-4 client-image-box"
                    v-for="(client, index) in data.client"
                    :key="index"
                  >
                    <a :href="client.link" target="_blank">
                      <img :src="client.logo" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="col-md-6 my-lg-3 my-4"
          v-if="data.project && data.project[0].name"
        >
          <div class="valuable-product">
            <h4><i class="fa fa-cubes"></i>{{ __("Projects") }}</h4>
            <div class="card card-body" v-if="Object(data.project).length > 0">
              <ul class="valuable-product-list">
                <li v-for="(project, index) in data.project" :key="index">
                  <i class="fa fa-check-circle"></i>
                  <span v-if="$root.lang == 'en'">
                    {{ project.name }}
                  </span>
                  <span v-if="$root.lang == 'jp'">
                    {{ project.name_japan }}
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="client p-0">
      <div class="row m-3">
        <div class="col-md-6 my-lg-3 my-4">
          <div class="gallery">
            <h4><i class="fa fa-picture-o"></i>{{ __("Photo Gallery") }}</h4>
            <div
              class="card card-body"
              v-if="Object(data.company_gallery).length > 0"
            >
              <div class="gallery-height">
                <div class="row m-0 p-0">
                  <div
                    class="col-md-4 m-0 p-1 gallery-image-box"
                    v-for="(company_gallery, index) in data.company_gallery"
                    :key="index"
                  >
                    <img
                      @click="openGallery(index)"
                      :src="company_gallery.image"
                      style="cursor: pointer; object-fit: contain"
                    />
                  </div>
                  <LightBox
                    :media="data.company_gallery"
                    ref="lightbox"
                    :show-caption="false"
                    :show-light-box="false"
                    :showThumbs="false"
                  >
                  </LightBox>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 my-lg-3 my-4">
          <div class="contact">
            <h4>
              <span class="fa fa-envelope-o"></span>
              {{ __("Contact Infomations") }}
            </h4>
            <div class="card card-body">
              <ul class="contact-list">
                <li>
                  <i class="fa fa-map-marker"></i>
                  <span v-if="$root.lang == 'en'">
                    {{ data.contact_address }}
                  </span>
                  <span v-if="$root.lang == 'jp'">
                    {{ data.contact_address_japan }}
                  </span>
                </li>
                <li><i class="fa fa-phone"></i> {{ data.contact_phone }}</li>
                <li>
                  <i class="fa fa-envelope-o"></i> {{ data.contact_email }}
                </li>
                <li>
                  <i class="fa fa-globe"></i>
                  {{ data.contact_website }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <pre>{{ data }}</pre> -->
  </div>
</template>


<script>
import LightBox from "vue-image-lightbox";
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import Topbar from "./../../../components/frontend/Topbar";
export default {
  name: "MemberProfile",
  components: {
    Topbar,
    LightBox,
  },
  data() {
    return {
      data: [],
    };
  },
  methods: {
    asyncData() {
      this.get_single_data("get-member-info", this.$route.params.slug);
    },
    openGallery(index) {
      this.$refs.lightbox.showImage(index);
    },
  },
  watch: {
    $route: {
      handler: "asyncData",
      immediate: true,
    },
  },
};
</script>
